import { Component } from '@angular/core';
import { Category, PAGE_CONTENT } from '../../content';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public headerRoutes: Array<{ title: string, url: string, subUrl: string }> = PAGE_CONTENT
    .reduce((acc: Array<{ title: string, url: string, subUrl: string }>, curr: Category) => {
      if (curr.pageContent.length) {
        acc.push({
          title: curr.title,
          url: curr.url,
          subUrl: (curr &&
            curr.pageContent &&
            curr.pageContent.length &&
            curr.pageContent[0].categories &&
            curr.pageContent[0].categories.length &&
            curr.pageContent[0].categories[0] &&
            curr.pageContent[0].categories[0].categoriesUrl) || ''
        });
      }
      return acc;
    }, []);
}
